import { lazy } from 'react';
export var LoginPageAsync = lazy(function () { return import('./LoginPage'); });
